module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_c('img', {
    staticClass: "img-responsive center-block logo",
    staticStyle: {
      "background": "none",
      "filter": "invert(1)"
    },
    attrs: {
      "src": "/static/img/image2vector.svg",
      "alt": "Logo"
    }
  }), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "id": "toggle-menu",
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    },
    on: {
      "click": _vm.barra
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])]), _vm._v(" "), (_vm.config.funcionamento === 'manual') ? _c('div', {
    staticClass: "modelSelect"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.bot_ativo),
      expression: "!bot_ativo"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("BOT DESLIGADO")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bot_ativo),
      expression: "bot_ativo"
    }],
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("BOT LIGADO")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('toggle-button', {
    attrs: {
      "color": _vm.color,
      "sync": true,
      "labels": true
    },
    on: {
      "change": _vm.alteraStatusBot
    },
    model: {
      value: (_vm.bot_ativo),
      callback: function($$v) {
        _vm.bot_ativo = $$v
      },
      expression: "bot_ativo"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "notifications-menu status-bot"
  }), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu notifications-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": _vm.demo.avatar,
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v("Olá, " + _vm._s(_vm.demo.displayName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated slideInDown",
    staticStyle: {
      "animation-duration": "0.5s"
    }
  }, [_c('li', [_c('ul', {
    staticClass: "menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.minhaConta
    }
  }, [_c('i', {
    staticClass: "fa fa-user text-aqua"
  }), _vm._v(" Minha Conta\n                    ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.novoUsuario
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus text-aqua"
  }), _vm._v(" Novo Usuário\n                    ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out text-aqua"
  }), _vm._v(" Sair\n                    ")])])])])])])])])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.logo,
      "empresa": _vm.demo.empresa
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n        " + _vm._s(_vm.$route.name.toUpperCase()) + "\n        "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.$route.name.toUpperCase()))])])]), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.pedidosImprimir), function(linha, index) {
    return (_vm.modal) ? _c('div', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "id": "pedido"
      }
    }, [_c('modal-pedido', {
      attrs: {
        "index": index,
        "linha": linha
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.mostrar) ? _c('beautiful-chat', {
    attrs: {
      "escolheuCliente": _vm.escolheuCliente,
      "mensagens": _vm.mensagens,
      "onMessageWasSent": _vm.onMessageWasSent,
      "newMessagesCount": _vm.newMessagesCount,
      "isOpen": _vm.isChatOpen,
      "close": _vm.closeChat,
      "open": _vm.openChat,
      "showEmoji": true,
      "showFile": true
    },
    on: {
      "sendMsg": _vm.sendMessage,
      "leuMsg": _vm.leuMsg,
      "atualizarImagem": _vm.atualizarImagem,
      "backChat": _vm.getMessages
    }
  }) : _vm._e(), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "href": "https://sevsolucoes.com"
    }
  }, [_vm._v("SEV")]), _vm._v(".")]), _vm._v(" All rights reserved.\n  ")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('audio', {
    attrs: {
      "src": "/static/audio/alerta.mp3",
      "loop": ""
    }
  }, [_vm._v("\n    O seu navegador não suporta o elemento "), _c('code', [_vm._v("audio")]), _vm._v(".\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-59e1c56f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 1252
// module chunks = 1